import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
    INVOICE_UPDATE_RESET,
    INVOICE_UPDATE_RETRIEVE_ERROR,
    INVOICE_UPDATE_RETRIEVE_LOADING,
    INVOICE_UPDATE_RETRIEVE_SUCCESS,
    INVOICE_UPDATE_UPDATE_ERROR,
    INVOICE_UPDATE_UPDATE_LOADING,
    INVOICE_UPDATE_UPDATE_SUCCESS,
    INVOICE_UPDATE_UPDATE_VIOLATIONS
} from './mutation-types'

const state = {
  retrieveError: '',
  retrieveLoading: false,
  retrieved: null,
  updated: null,
  updateError: '',
  updateLoading: false,
  violations: null
}

function retrieveError(retrieveError) {
  return {type: INVOICE_UPDATE_RETRIEVE_ERROR, retrieveError};
}

function retrieveLoading(retrieveLoading) {
  return {type: INVOICE_UPDATE_RETRIEVE_LOADING, retrieveLoading};
}

function retrieveSuccess(retrieved) {
  return {type: INVOICE_UPDATE_RETRIEVE_SUCCESS, retrieved};
}

function updateError (updateError) {
  return {type: INVOICE_UPDATE_UPDATE_ERROR, updateError}
}

function updateLoading (updateLoading) {
  return {type: INVOICE_UPDATE_UPDATE_LOADING, updateLoading}
}

function updateSuccess (updated) {
  return {type: INVOICE_UPDATE_UPDATE_SUCCESS, updated}
}

function violations (violations) {
  return {type: INVOICE_UPDATE_UPDATE_VIOLATIONS, violations}
}

function reset () {
  return {type: INVOICE_UPDATE_RESET}
}

const getters = {
  retrieveError: state => state.retrieveError,
  retrieveLoading: state => state.retrieveLoading,
  retrieved: state => state.retrieved,
  updated: state => state.updated,
  updateError: state => state.updateError,
  updateLoading: state => state.updateLoading,
  violations: state => state.violations
}

const actions = {
  retrieve({ commit }, id) {
    commit(retrieveLoading(true));
    commit(retrieveError(null));
   return http.fetch('/invoices/' + id)
      .then(response => response.json())
      .then(data => {
        const ivoiceData = {
          id: data.id,
          fullNumber: data.fullNumber,
          customer: data.customer,
          customerData: {
            name: data.customerData.name,
            nip: data.customerData.nip,
            regon: data.customerData.regon,
            customerAddress: {
              city: data.customerData.customerAddress.city,
              number: data.customerData.customerAddress.number,
              postalCode: data.customerData.customerAddress.postalCode,
              street: data.customerData.customerAddress.street,
              country: data.customerData.customerAddress.country
            }
          },
          items: data.items,
          correctedInvoice: data.correctedInvoice,
          correctedInvoiceItems: data.correctedInvoiceItems,
          correction: data.correction,
          paymentDate: data.paymentDate,
          endDate: data.endDate,
          createDate: data.createDate,
          comments: data.comments,
          currency: data.currency['@id'],
          paymentType: data.paymentType['@id'],
          amount: data.amount,
          paid: data.paid,
        }
        commit(retrieveLoading(false));
        commit(retrieveSuccess(ivoiceData));
      })
      .catch(e => {
        commit(retrieveLoading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(retrieveError(e.message));
      });
  },
  update ({commit, state}, { item, values }) {
    commit(updateError(null))
    commit(violations({}))
    commit(updateLoading(true))
    if(typeof values.amount == 'string'){
      values.amount = values.amount.replace(',','.').replace(' ','');
    }
    for(let i = 0; i < values.items.length; i++){
      if(typeof values.items[i].amount == 'string'){
        values.items[i].amount = values.items[i].amount.replace(',','.').replace(' ','');
      }
      if(typeof values.items[i].price == 'string'){
        values.items[i].price = values.items[i].price.replace(',','.').replace(' ','');
      }
      if(values.items[i].amount == null || values.items[i].price == ''){
        values.items[i].amount = 0;
      }
      if(values.items[i].price == null || values.items[i].price == ''){
        values.items[i].price = 0;
      }
      values.items[i].amount = parseFloat(values.items[i].amount);
      values.items[i].price = parseFloat(values.items[i].price);
    }
    values.amount = parseFloat(values.amount);
    if(values.correctedInvoice && values.correctedInvoice['@id']){
      values.correctedInvoice = values.correctedInvoice['@id']
    }
    return http.fetch('/invoices/' + item.id, {
        method: 'PUT',
        body: JSON.stringify(values),
      }
    )
      .then(response => response.json())
      .then(data => {
        commit(updateLoading(false))
        commit(updateSuccess(data))
      })
      .catch(e => {
        commit(updateLoading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          return
        }

        commit(updateError(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [INVOICE_UPDATE_RETRIEVE_LOADING] (state, payload) {
    state.retrieveLoading = payload.retrieveLoading
  },
  [INVOICE_UPDATE_RETRIEVE_ERROR] (state, payload) {
    state.retrieveError = payload.retrieveError
  },
  [INVOICE_UPDATE_RETRIEVE_SUCCESS](state, payload) {
    state.retrieved = payload.retrieved;
  },
  [INVOICE_UPDATE_UPDATE_LOADING] (state, payload) {
    state.updateLoading = payload.updateLoading
  },
  [INVOICE_UPDATE_UPDATE_ERROR] (state, payload) {
    state.updateError = payload.updateError
  },
  [INVOICE_UPDATE_UPDATE_SUCCESS] (state, payload) {
    state.updated = payload.updated
    state.violations = null
  },
  [INVOICE_UPDATE_UPDATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [INVOICE_UPDATE_RESET] (state) {
    state.retrieveError = ''
    state.retrieveLoading = false
    state.updated = null
    state.updateError = ''
    state.updateLoading = false
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/update.js